import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { AbtestConfigProviderService } from '@core/ab-testing/abtest-config-provider.service';
import { CMSService, STANDALONE_BOOKERS } from '@core/cms';
import { JbI18nUtilsService, JbLocaleCodes } from 'jb-component-library';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'dot-booker-air-standalone',
  templateUrl: './booker-air-standalone.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookerAirStandaloneComponent implements OnInit {
  @Input() disableAutoSubmit: 'true' | 'false' | boolean = false;
  @Input() saveToUrlParam = false;
  @Input() tripType: string;
  @Input() isTrueBlue: 'true' | 'false' | boolean = false;
  @Input() destinationAirport: string;
  @Input() originAirport: string;
  @Input() departDate: string;
  @Input() returnDate: string;
  @Input() travelerCountAdult: number;
  @Input() travelerCountChild: number;
  @Input() travelerCountInfant: number;
  @Input() multiFlights: {
    origin: string;
    destination: string;
    departDate: string;
  }[];
  @Input() promoCode: string;
  @Input() dataEndpoint: string;
  @Input() languageCode: string;

  @Output() jbBookerSubmit = new EventEmitter();

  getBookerData$: Observable<any>;

  constructor(
    private cmsService: CMSService,
    private abtestConfigProviderService: AbtestConfigProviderService,
    private jbI18nService: JbI18nUtilsService,
  ) {}

  ngOnInit() {
    this.getBookerData$ = this.abtestConfigProviderService.loadConfig().pipe(
      switchMap(_ => {
        // we want to rely on the cookie lang value primarily
        // however we will treat languageCode as an override
        const cookieLang = this.cmsService.getCookie('lang');

        if (cookieLang !== 'en' && JbLocaleCodes[cookieLang]) {
          this.jbI18nService.setLocale(JbLocaleCodes[cookieLang]);
        }

        return this.cmsService.getBookerData(STANDALONE_BOOKERS.NGB);
      }),
    );
  }
}
